// mutation types
export const SET_SEARCH_PARAMS = 'setSearchParams';
export const SET_GEOLOCATION_PERMISSION_DECLINED = 'setGeolocationPermissionDeclined';
export const SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED = 'setLargeUserDistanceWarningAcknowledged';

const state = {
  searchParams: {
    place: '',
    lat: '',
    lng: '',
    spatial_pt: ''
  },
  geolocationPermissionDeclined: false,
  largeUserDistanceWarningAcknowledged: false,
};

const getters = {

};

const actions = {

};

const defaultSearchParams = () => ({
  place: '',
  lat: '',
  lng: '',
  spatial_pt: '',
});

const mutations = {
  [SET_SEARCH_PARAMS](_state, searchParams) {
    const normalizedSearchParams = {
      ...searchParams,
    };
    const shouldResetStoredSearchParams = normalizedSearchParams.reset_filters === true
      || normalizedSearchParams.reset_filters === '1'
      || normalizedSearchParams.reset_filters === 1;
    delete normalizedSearchParams.reset_filters;
    const lat = parseFloat(normalizedSearchParams.lat);
    const lng = parseFloat(normalizedSearchParams.lng);

    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      normalizedSearchParams.lat = lat;
      normalizedSearchParams.lng = lng;
      normalizedSearchParams.spatial_pt = `${lat},${lng}`;
    } else if (normalizedSearchParams.spatial_pt) {
      const [spatialLatRaw, spatialLngRaw] = `${normalizedSearchParams.spatial_pt}`.split(',');
      const spatialLat = parseFloat(spatialLatRaw);
      const spatialLng = parseFloat(spatialLngRaw);
      if (Number.isFinite(spatialLat) && Number.isFinite(spatialLng)) {
        normalizedSearchParams.lat = spatialLat;
        normalizedSearchParams.lng = spatialLng;
        normalizedSearchParams.spatial_pt = `${spatialLat},${spatialLng}`;
      }
    }

    if (shouldResetStoredSearchParams) {
      _state.searchParams = defaultSearchParams();
    }
    Object.assign(_state.searchParams, normalizedSearchParams);
  },
  [SET_GEOLOCATION_PERMISSION_DECLINED](_state, isDeclined) {
    _state.geolocationPermissionDeclined = isDeclined === true;
  },
  [SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED](_state, isAcknowledged) {
    _state.largeUserDistanceWarningAcknowledged = isAcknowledged === true;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
